import { render, staticRenderFns } from "./ClientHaloTickets.vue?vue&type=template&id=94742298&scoped=true&"
import script from "./ClientHaloTickets.vue?vue&type=script&lang=js&"
export * from "./ClientHaloTickets.vue?vue&type=script&lang=js&"
import style0 from "./ClientHaloTickets.vue?vue&type=style&index=0&id=94742298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94742298",
  null
  
)

export default component.exports